import { OptionTemplate } from "shared/api/middleware-api-client";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";
import { GlassCard } from "./components/GlassCard";
import { SelectionWrapper } from "widgets/configurator/door-options-controls/SelectionWrapper";
import { useGlassHelper } from "../helpers/useGlassHelper";

const GlassOptionControls = ({ isBusinessDoor = false }) => {
  const {
    doorOptionsLoading,
    doorOptionsLoadError,
    doorOptions,
    selectedDoor,
    color,
    glassCategories,
    onUpdateGlass,
  } = useGlassHelper({ isBusinessDoor });

  if (doorOptionsLoading) return <div>Loading...</div>;
  if (doorOptionsLoadError) return <div>Error!</div>;
  if (!selectedDoor || !doorOptions || !color) return null;

  return (
    <div className="gg-mt-4">
      <>
        {glassCategories.map((category, id) => (
          <div
            key={`glass-category-${id}`}
            className={concatClassnames(
              "gg-w-full gg-border-t gg-pt-4",
              id !== glassCategories.length - 1 && "gg-pb-4",
              id === 0 && isBusinessDoor && "gg-border-t-0",
            )}
          >
            <Heading headingLevel="h5" className="gg-font-bold">
              {category.title}
            </Heading>
            <Text className="gg-purple-300 gg-mb-4 gg-text-sm">
              {category.description}
            </Text>
            <SelectionWrapper>
              {category.items.map((glass: OptionTemplate, id) => {
                return (
                  <GlassCard
                    key={id}
                    glass={glass}
                    updateGlass={onUpdateGlass}
                    selectedDoor={selectedDoor}
                  />
                );
              })}
            </SelectionWrapper>
          </div>
        ))}
      </>
    </div>
  );
};
export default GlassOptionControls;
